'use client'
import React from 'react'
import IndHeroSection from './components/IndHeroSection'
import IndSectionTwo from './components/IndSectionTwo'
import { useIndustriesNavbarScroll } from '@/Hooks'
import AppSolutions from './components/AppSolutions'
import SupplyChainFromStrategy from './components/SupplyChainFromStrategy'
import SupplyChainWeOffer from './components/SupplyChainWeOffer'
import SupplyChainWhyChoose from './components/SupplyChainWhyChoose'
import {
   ContactUsForm,
   FAQs,
   GameChangingIdea,
   WordsOfAppreciation,
} from '@/components'

const faqData = [
   {
      question: 'What is software development for supply chains and logistics?',
      answer:
         'Software developers create specific digital programs that optimize inventory controls alongside transportation systems and warehousing operations and distribution delivery processes. The software solutions increase operational efficiency and implement automated workflows because they offer better supply chain visibility.',
   },
   {
      question: 'How does logistics software increase the efficiency of a supply chain?',
      answer:
         'The efficiency of logistics operations increases through software solutions that provide optimal routing functionality together with automated dispatching and real-time shipment tracking capacities along with artificial intelligence-based demand predictions. Supply chain performance enhances through these measures which both decrease delays and minimize costs.',
   },
   {
      question: 'What features should a logistics management software include?',
      answer:
         'A complete logistics software platform needs real-time shipment tracking in addition to route optimization and automated inventory control combined with fleet monitoring capabilities as well as warehouse automation platforms and applications for predictive analytics in conjunction with interfaces between ERP and IoT systems.',
   },
   {
      question: 'How much does it cost to develop supply chain & logistics software?',
      answer:
         'A software development project cost typically depends on the combination of platform functionality needs along with system difficulty level along with integration possibilities and capacity for future growth. Your business needs determine which basic or advanced AI-driven solution to implement from your investment.',
   },
   {
      question: 'What are the benefits of AI-powered logistics software?',
      answer:
         'By implementing AI-powered logistics software organizations gain better demand forecasting capabilities together with improved fleet operation management and automated decision processes as well as enhanced route plan optimization and system performance monitoring capabilities. The software creates cost efficiencies and speedier deliveries and better resource allocation.',
   },
   {
      question: 'Is it possible to integrate logistics software with ERP and CRM systems?',
      answer:
         'The modern logistics system properly merges with ERP and CRM and WMS and IoT tracking systems to enable continuous data exchange while establishing automated business operations and enhanced supply chain management.',
   },
   {
      question: 'How is supply chain visibility enhanced by real-time tracking?',
      answer:
         'The real-time monitoring system helps businesses oversee package movements while it enables them to forecast delivery problems and track optimal routes and communicate better with customers. Logistics software creates transparent supply chain operations by reducing operational problems that improve overall efficiency.',
   },
   {
      question: 'What security measures are included in logistics software?',
      answer:
         'The software defends logistics data through AES algorithm encryption and access limit controls alongside blockchain implementation and secure APIs and GDPR protocol and artificial intelligence-based fraud protection.',
   },
   {
      question: 'How long does it take to develop a logistics software solution?',
      answer:
         'Development timelines vary based on project complexity. A basic logistics platform may take 3–6 months, while a fully customized enterprise solution with AI and cloud integration can take 6–12 months.',
   },
   {
      question:
         'Why choose Benzatine for supply chain & logistics software development?',
      answer:
         'Benzatine specializes in AI-powered, scalable logistics solutions with seamless ERP integration, predictive analytics, real-time tracking, and custom automation, ensuring optimized supply chain management.',
   },
]; 

function SupplyChainAndLogisticsPage() {
   useIndustriesNavbarScroll()
   return (
      <>
         <IndHeroSection />
         <IndSectionTwo />
         <AppSolutions />
         <SupplyChainFromStrategy />
         <SupplyChainWeOffer />
         <SupplyChainWhyChoose />
         <GameChangingIdea />
         <section className="section appreciation-slider-section page_top_section section_secondary_bg">
            <WordsOfAppreciation />
         </section>

         <FAQs faqsConst={faqData} />

         <ContactUsForm />
      </>
   )
}

export default SupplyChainAndLogisticsPage
